var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('copy')}}},[_c('div',{staticClass:"inline-block mr-1"},[_c('CopyIcon')],1),_c('span',{staticClass:"text"},[_vm._v("复制内容")])])}
var staticRenderFns = []

export { render, staticRenderFns }